var map = {
	"./east.png": 203,
	"./north-east.png": 653,
	"./north-west.png": 843,
	"./north.png": 499,
	"./south-east.png": 459,
	"./south-west.png": 901,
	"./south.png": 369,
	"./west.png": 997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;